import { useTranslation } from "react-i18next";
import { Coins } from "@phosphor-icons/react";
import { useScrollReveal } from "../hooks/useScrollReveal";

const BlockchainsSection = () => {
  const { t } = useTranslation();
  const [ref, isVisible] = useScrollReveal();

  return (
    <section className="relative lg:min-h-screen flex items-center overflow-hidden py-10 lg:py-[120px]" id="blockchains">

      <style>{`
        .hero3-bg {
          background: #030305;
          position: absolute;
          inset: 0;
        }
        .hero3-bg::after {
          content: "";
          position: absolute;
          top: 40%;
          left: 45%;
          width: 900px;
          height: 900px;
          transform: translate(-50%, -50%);
          background: radial-gradient(circle, rgba(60,20,120,0.15) 0%, rgba(20,5,60,0.06) 40%, transparent 65%);
          pointer-events: none;
        }
      `}</style>

      <div className="hero3-bg" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div ref={ref} className="grid lg:grid-cols-[55%_45%] gap-6 items-center">

          {/* Text — shows first on mobile */}
          <div className="space-y-6 order-1 lg:order-2">
            {/* Badge */}
            <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full border border-violet-400/40 bg-violet-500/[0.1]"
              style={{ boxShadow: '0 0 20px rgba(139,92,246,0.2), inset 0 0 15px rgba(139,92,246,0.05)' }}>
              <Coins size={20} weight="duotone" className="text-violet-400" style={{ filter: 'drop-shadow(0 0 8px rgba(139,92,246,0.8))' }} />
              <span className="text-violet-300 text-sm sm:text-base font-bold tracking-[0.12em] uppercase"
                style={{ textShadow: '0 0 15px rgba(139,92,246,0.6)' }}>
                {t("heroTokens.badge")}
              </span>
            </div>

            {/* Title */}
            <h2 className="text-4xl sm:text-5xl md:text-6xl xl:text-[4.5rem] font-black leading-[0.9] tracking-tight">
              <span className="text-white">{t("heroTokens.title1")} </span>
              <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'linear-gradient(135deg, #a855f7 0%, #9333ea 40%, #e879f9 100%)' }}>
                {t("heroTokens.title2")}
              </span>
            </h2>

            {/* Description */}
            <p className="text-gray-400 text-base sm:text-lg max-w-lg leading-relaxed">
              {t("heroTokens.description")}
            </p>
          </div>

          {/* Image — shows on all screens */}
          <div className="order-2 lg:order-1">
            <div className="relative flex items-center justify-center">
              <img
                src="/images/hero-tokens.webp"
                alt="Lumina Wallet - 17,567 Tokens"
                className="w-full max-w-xs md:max-w-2xl h-auto mx-auto"
                width="1024"
                height="768"
                loading="eager"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlockchainsSection;
